<script setup lang="ts">
defineProps<{
  explodeHeight?: boolean;
  /** works with explodeHeight, to make sure content does not expand the container */
  clipContent?: boolean;
}>();
</script>

<template>
  <div :class="['widget-layout-row', $style.container, explodeHeight && $style.explodeHeight, clipContent && $style.clipContent]">
    <div :class="[$style.widget, explodeHeight && $style.explodeHeight, clipContent && $style.clipContent]">
      <slot name="widget" />
    </div>
  </div>
</template>

<style module>
.container {
  display: flex;
  flex-direction: column;
  margin-bottom: 1px;
}

.container:last-child {
  margin-bottom: 0;
}

.widget {
  display: flex;
  flex-direction: row;
  width: 100%;
  /* padding-left: 0.75rem;
  padding-right: 0.75rem; */
}

.widget.widgetScroll {
  overflow: hidden;
}

.explodeHeight {
  flex: 1;
}

.clipContent {
  min-height: 0;
}
</style>
